import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Input,
  Row,
  Card,
  Form,
  Col,
  Typography,
  Button,
  DatePicker,
  Image,
  Layout,
  notification,
  Modal,
  Select,
  message,
} from "antd";
import { useNavigate } from "react-router-dom";
import { StyledAlert } from "../../styles";
import actions from "../../redux/donorDetails/actions";
import config from "../../Services/apiEndPoints";
import dayjs from "dayjs";
import "../../Screens/form.css";
import "../MyDonations/datePicker.css";
import axiosInstance from "../../Services/axiosIntercepter";

const { TextArea } = Input;
const { Header } = Layout;
const { Option } = Select;

export default function DonationDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [donationsForm] = Form.useForm();
  const [razorpayScriptLoaded, setRazorpayScriptLoaded] = useState(false);

  const donorId =
    localStorage.getItem("donorId") || sessionStorage.getItem("donor-Id");

  const { successMessage, errorMessage, isFetching, actionType } = useSelector(
    (state) => state.donor
  );

  const today = dayjs();
  const defaultDate = today.day() === 0 ? today : null;
  const mobileNum = localStorage.getItem("mobileNumber");

  const typeOfUser =
    sessionStorage.getItem("typeOfUser") || localStorage.getItem("typeOfUser");

  const handlePrevious = () => {
    navigate("/donorPersonalDetails");
  };

  useEffect(() => {
    if (actionType === actions.DONATION_DETAILS_CREATE_SUCCESS) {
      notification.success({
        message: successMessage,
      });
      dispatch(actions.resetDonorPersonalDetails());
    } else if (actionType === actions.DONATION_DETAILS_CREATE_ERROR) {
      notification.success({
        message: errorMessage,
      });
      dispatch(actions.resetDonorPersonalDetails());
    }
  }, [actionType]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;

    script.onload = () => setRazorpayScriptLoaded(true);
    script.onerror = () => console.error("Failed to load Razorpay script");

    document.body.appendChild(script);

    // Cleanup
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const enableFutureSundays = (current) => {
    const isFuture = current && current.isAfter(dayjs(), "day");
    const isSunday = current && current.day() === 0;
    return !(isFuture && isSunday);
  };

  const handleSavePayment = async () => {
    const donorId = localStorage.getItem("donorId");
    const mail = localStorage.getItem("email");

    try {
      const values = await donationsForm.validateFields();
      const payload = {
        donorId: donorId,
        amount: values.amount,
        email: mail,
      };
      if (values.amount > 25000) {
        dispatch(actions.sendmail(config.sendmoneyemail, payload));

        const modal = Modal.info({
          title: "",
          width: 650,
          content: (
            <div>
              <StyledAlert
                message="Thank you for your interest! For donations above ₹25,000, please contact the Sri Rama Navami team at sriramanavami@yahoo.com."
                type="info"
              />
            </div>
          ),
          footer: (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <Button
                key="confirm"
                type="primary"
                onClick={() => {
                  const data = {
                    ...payload,
                    type: "donor",
                  };

                  dispatch(actions.sendmail(config.sendmoneyemail, data));

                  modal.destroy();
                  message.success("Mail sent successfully!");
                }}
                style={{ width: 80, marginTop: 20 }}
              >
                Send Mail
              </Button>
            </div>
          ),
          onOk() {
            modal.destroy();
          },
          closable: true,
        });
      } else {
        if (!razorpayScriptLoaded) {
          console.error("Razorpay script not loaded yet.");
          return;
        }

        try {
          values["donor_id"] = donorId;

          // Fix 1: Correct type check and use dayjs directly
          if (typeOfUser?.toLowerCase() === "annadhanam") {
            const annadanamDate = values?.annadanam_date;

            // Fix 2: Remove Date conversion and timezone offset manipulation
            if (annadanamDate && dayjs.isDayjs(annadanamDate)) {
              values["annadanam_date"] = annadanamDate.format("YYYY/MM/DD");
            }
          }

          values["donation_type"] =
            typeOfUser === "annadhanam" ? "Annadanam" : "Festival";

          const { data } = await axiosInstance.post(`${config.razorPay}`, {
            amount: values.amount, // Amount in subunits (e.g., paise)
            currency: "INR",
            donation_type: values.donation_type,
          });

          // Fix 3: Create payment handler with current values
          const handler = (response) => {
            const dispatchValues = {
              ...values,
              paymentId: response?.razorpay_payment_id,
              annadanam_date: values.annadanam_date, // Ensure final formatted value
            };
            console.log("Dispatch values:", dispatchValues);
            dispatch(
              actions.createDonationDetails(
                config.donationDetailsCreate,
                dispatchValues
              )
            );

            navigate("/paymentsuccess", {
              state: {
                from: "beforeDashboard",
                paymentId: response?.razorpay_payment_id,
                amount: values.amount,
                currentDate: dayjs().format("DD-MM-YYYY"),
              },
            });
          };


          const options = {
            key:
              values.donation_type === "Annadanam"
                ? "rzp_live_ZtaFUxUoEpyF29"
                : "rzp_live_fxzBCN5ClNn1Ut", // Your Razorpay Key ID,
            amount: data?.data?.amount,
            currency: data?.data?.currency,
            order_id: data?.data?.orderId, // Razorpay order ID received from the backend
            name: "Payment",
            description: "Integration with Razorpay",
            handler,
            notes: values,
           prefill: {
              name: localStorage.getItem("name") || sessionStorage.getItem("name"),
              email: localStorage.getItem("email") || sessionStorage.getItem("email"),
              contact: mobileNum,
            },
            theme: {
              color: "#F37254",
            },
          };


          // Create Razorpay instance and open the payment window
          const razorpay = new window.Razorpay(options);
          razorpay.open();
        } catch (error) {
          console.error("Error creating Razorpay order: ", error);
        }
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  useEffect(() => {
    // Push the current state to history to prevent back navigation
    window.history.pushState(null, null, "", window.location.href);

    const handlePopState = () => {
      // This will force the user to stay on the current page
      window.history.pushState(null, null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <div className="responsive-container">
      <Card className="premium-card" style={{ maxWidth: "700px" }}>
        <div className="form-header">
          <img
            src="/favicon.ico"
            alt="Logo"
            className="form-logo"
          />
          <Typography.Title level={2} style={{ margin: 0, color: "var(--text-main)" }}>
            Donation Details
          </Typography.Title>
          <Typography.Text type="secondary">
            Provide details for your generous contribution
          </Typography.Text>
        </div>

        <Form
          form={donationsForm}
          layout="vertical"
          initialValues={{ annadanam_date: defaultDate }}
          requiredMark="optional"
        >
          <Row gutter={[24, 0]}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="amount"
                label="Donation Amount (₹)"
                rules={[
                  { required: true, message: "Donation amount is required." },
                  {
                    validator: (_, value) => {
                      if (value && value < 10) {
                        return Promise.reject("Min amount is 10 rupees.");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  placeholder="Enter Amount"
                  className="custom-input"
                  type="number"
                  prefix="₹"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="in_the_favor_of" label="In the Name Of">
                <Input
                  placeholder="Enter Name"
                  className="custom-input"
                />
              </Form.Item>
            </Col>

            {typeOfUser === "annadhanam" && (
              <Col xs={24}>
                <Form.Item
                  label="Annadanam Date"
                  name="annadanam_date"
                  rules={[
                    {
                      required: true,
                      message: "Date is required.",
                    },
                  ]}
                >
                  <DatePicker
                    className="custom-input"
                    format="DD-MM-YYYY"
                    disabledDate={enableFutureSundays}
                    style={{ width: "100%", height: "42px" }}
                  />
                </Form.Item>
              </Col>
            )}

            {typeOfUser !== "annadhanam" && (
              <Col xs={24}>
                <Form.Item
                  name="notes"
                  label="Purpose"
                >
                  <Select
                    className="custom-select"
                    placeholder="Select a purpose type"
                  >
                    <Option value="Donation">Donation</Option>
                    <Option value="Festival Annadanam">Festival Annadanam</Option>
                    <Option value="Manjal Kum-kum">Manjal Kum-kum</Option>
                  </Select>
                </Form.Item>
              </Col>
            )}
          </Row>

          <div style={{ marginTop: 24, display: "flex", justifyContent: "space-between", gap: "12px" }}>
            <Button
              className="premium-button"
              onClick={handlePrevious}
              style={{ background: "#cbd5e0 !important", color: "#4a5568 !important", width: "140px", boxShadow: "none" }}
            >
              Back
            </Button>
            <Button
              type="primary"
              onClick={handleSavePayment}
              className="premium-button"
              style={{ width: "200px" }}
              loading={isFetching}
            >
              Make Payment
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
}
